import React from 'react';
import Checkmark from '../../../assets/svg/checkmark.svg.js';

/**
 * @deprecated
 * Please use: <Icon icon='icon-key-x' /> Component as an alternative
 */
const CheckmarkIcon = _ref => {
  let {
    width = 24,
    height = 24
  } = _ref;
  return /*#__PURE__*/React.createElement("img", {
    src: Checkmark,
    alt: "icon-checkmark",
    width: width,
    height: height
  });
};
var CheckmarkIcon$1 = CheckmarkIcon;

export { CheckmarkIcon$1 as default };
//# sourceMappingURL=CheckmarkIcon.js.map
